/* eslint-disable no-param-reassign */
import type { FilterBarState } from './types';
import { DEFAULT_PROJECT_KEY, VISUAL_SLICE_NAME } from './constants';

export interface SavedVisualBuildDetailsFilters {
  status?: string[] | null;
  search?: string;
  os?: string[] | null;
  browser?: string[] | null;
  device?: string[] | null;
  groupBy?: string[] | null;
}

export const serializeFilters = (state: FilterBarState) => {
  const savedFilterState = {
    status: state.status.value ?? '',
    browser: state.browser.value ?? '',
    groupBy: state.groupBy.value ?? '',
    search: state.search.inputValue ?? '',
    os: state.os.value ?? '',
    device: state.device.value ?? '',
  };

  const nonEmptyEntries = Object
    .entries(savedFilterState)
    .filter(([, value]) => (
      Array.isArray(value) ? value.length > 0 : !!value
    ));

  return Object.fromEntries(nonEmptyEntries);
};

export const parseSavedFilters = (search: string, project: string | null | undefined) => {
  const params = new URLSearchParams(search);

  let savedSettings: SavedVisualBuildDetailsFilters = {};

  // Should be replaced with params.size when we can upgrade TypeScript
  if ([...params].length > 0) {
    savedSettings = {
      status: params.get('status')?.split(','),
      browser: params.get('browser')?.split(','),
      groupBy: params.get('groupBy')?.split(','),
      search: params.get('search') ?? '',
      os: params.get('os')?.split(','),
      device: params.get('device')?.split(','),
    };
  } else {
    try {
      const allSettings = JSON.parse(localStorage.getItem(VISUAL_SLICE_NAME) ?? '{}');
      savedSettings = allSettings[project ?? DEFAULT_PROJECT_KEY] ?? {};
    } catch {
      savedSettings = {};
    }
  }

  return savedSettings;
};
